export const AMERICAN_EXPRESS_FORMATTED = 'AMEX';

export const DUTCHIE_DATE_FORMAT = 'M/D/YY';

export const FF_BILLING_MANAGEMENT_V2 = 'rollout.billing-management-v2';
// TODO move discounts flags to admin/src/dispensary-admin/promote/specials/constants/ld-feature-flags.ts
export const FF_ENTERPRISE_SPECIALS = 'rollout.use-enterprise-specials';
export const FF_GET_ENTERPRISE_SPECIALS_V3 = 'rollout.get-enterprise-specials-v3';
export const FF_LOCAL_TIME = 'rollout.enterprise-specials-local-time';
export const FUSE_DEFAULT_SEARCH_THRESHOLD = 0.3;

export const PAYMENT_SOURCE_CARD_BRAND_AMEX = 'american_express';
export const PAYMENT_SOURCE_TYPE_DIRECT_DEBIT = 'direct_debit';

// For future LD flags for the Discounts team, please use
// admin/src/dispensary-admin/promote/specials/constants/ld-feature-flags.ts
